import { useQuery } from '@tanstack/react-query';

import {
  FetchWalletsRequest,
  FetchWalletsResponse,
  walletsService,
} from '@aslanpay/portal-common-lib';

const useFetchWallets = (
  { ids, companyIds, employeeIds, status, sortBy, sort, page, size }: FetchWalletsRequest,
  enabled = true
) => {
  return useQuery<FetchWalletsResponse, Error>(
    ['fetchWallets', ids, companyIds, employeeIds, status, sortBy, sort, page, size],
    () =>
      walletsService.fetchWallets({
        ids,
        companyIds,
        employeeIds,
        status,
        sortBy,
        sort,
        page,
        size,
      }),
    { enabled }
  );
};

export default useFetchWallets;
